import React, { useEffect, useRef, useState, useMemo } from 'react'
import { useHistory, withRouter, RouteComponentProps } from 'react-router-dom'
import { toast, ToastOptions } from 'react-toastify'

import {
  RelacaoDocumentosTurmaCertificacao,
  ResumoDeDocumentosDeSaidaMapper,
  selecaoDeDocumentosParaEnvio,
  UploadDocumentos,
  useRelacaoDeDocumentos
} from 'src/compartilhados'
import {
  FormUnform,
  Botao,
  Breadcrumb,
  Cabecalho,
  focarPrimeiroCampoOuEditorComErro,
  IconeBack,
  Link,
  ModalRef,
  SelectOpcao,
  SubTitulo,
  InputUnform,
  NumeroInputUnform,
  Spacer,
  Modal,
  CalendarioUnform,
  Visao,
  AutenticacaoContainer,
  ErroLayoutContainer
} from 'src/componentes'
import { SelectUnform } from 'src/componentes/unform/select'
import { TurmaCertificacaoPayload } from 'src/dto'
import { ContainerDadosGrande } from 'src/paginas/professor/meu-cadastro/styles'
import { RotasTurmaCertificacao } from 'src/rotas'
import { Api } from 'src/servicos'
import { RequisitarTodosProfessoresCertificacao } from 'src/servicos/api'
import {
  SituacaoTurmaCertificacao,
  TipoTurmaCertificacao,
  TipoCertificado,
  DivisaoCursoCertificacao,
  ModuloTurmaCertificacao,
  DisciplinaTurmaCertificacao
} from 'src/tipos'
import { ModoPaginaCadastro } from 'src/tipos/genericos'

import { ContainerCertificacao } from '../../styles'
import { DesvincularDisciplinaModulo } from './componentes/desvincular-disciplina-modulo'
import DocumentosTurmaCertificacao, {
  DocumentosTurmaCertificacaoHandles
} from './componentes/documentos/documentos-turma-certificacao'
import { ListaModuloDisciplina } from './componentes/lista-modulos-disciplina'
import { ModalEditarModulo } from './componentes/modal-editar-modulo'
import { ModalEditarModuloCertificacaoRef } from './componentes/modal-editar-modulo/tipos'
import { ModalExcluirDisciplina } from './componentes/modal-excluir-disciplina'
import { ModalIncluirDisciplina } from './componentes/modal-incluir-disciplina'
import { ModalIncluirDisciplinaCertificacaoRef } from './componentes/modal-incluir-disciplina/tipos'
import { ModalIncluirModulo } from './componentes/modal-incluir-modulo'
import { ModalIncluirModuloCertificacaoRef } from './componentes/modal-incluir-modulo/tipos'
import { ModalVincularDisciplinaModulo } from './componentes/modal-vincular-disciplina-modulo'
import { ModalVincularDisciplinaModuloRef } from './componentes/modal-vincular-disciplina-modulo/tipos'
import { createSchema } from './schema'
import {
  Container,
  ContainerMain,
  ContainerDadosMedio,
  Conteudo,
  ContainerDados,
  ContainerAcoes,
  FormContainer,
  ContainerLink,
  SecaoPrimaria
} from './styles'
import { DisciplinaCertificacaoVinculada } from './tipos'

export interface PaginaTurmaCertificacaoProps
  extends RouteComponentProps<{
    id?: string
    tipo?: TipoTurmaCertificacao
  }> {
  modo?: ModoPaginaCadastro
}

const PaginaTurmas: React.FC<PaginaTurmaCertificacaoProps> = ({
  match,
  modo
}) => {
  const { visao } = AutenticacaoContainer.useContainer()

  const modalRef = useRef<ModalRef>(null)
  const modalIncluirModuloRef = useRef<ModalIncluirModuloCertificacaoRef>(null)
  const modalIncluirDisciplinaRef = useRef<ModalIncluirDisciplinaCertificacaoRef>(
    null
  )
  const modalEditarModuloRef = useRef<ModalEditarModuloCertificacaoRef>(null)
  const modalDisciplinaModuloRef = useRef<ModalRef>(null)
  const modalDesvincularDisciplinaref = useRef<ModalVincularDisciplinaModuloRef>(
    null
  )
  const modalExcluirDisciplinaref = useRef<ModalIncluirDisciplinaCertificacaoRef>(
    null
  )

  const documentosRef = useRef<DocumentosTurmaCertificacaoHandles>(null)
  const history = useHistory()
  const usuario = localStorage.getItem('@ipgs/usuario')
  const usuarioObj = JSON.parse(usuario)
  const usuarioId = usuarioObj.id
  const [turma, definirTurma] = useState<TurmaCertificacaoPayload | undefined>(
    undefined
  )
  const [titulo] = useState(
    `${modo === ModoPaginaCadastro.Inclusao ? 'Inclusão' : 'Edição'} da Turma`
  )
  const [pronto, definirPronto] = useState(true)
  const [professores, definirProfessores] = useState([])
  const [carregando, definirCarregando] = useState(false)
  const [opcoesCurso, definirOpcoesCurso] = useState<SelectOpcao[]>([])
  const [opcoesProfessor, definirOpcoesProfessor] = useState<SelectOpcao[]>([])
  const [tipoTurma, definirTipoTurma] = useState<SelectOpcao>()
  const [idTurma, setIdTurma] = useState<string>()
  const { documentos, atualizar, reiniciar } = useRelacaoDeDocumentos(
    RelacaoDocumentosTurmaCertificacao
  )
  const [divisaoTurma, definirDivisao] = useState<string>(undefined)
  const [possuiDocumentosSalvos, definirPossuiDocumentosSalvos] = useState(
    false
  )

  const [modulosTurma, definirModulosTurma] = useState<
    ModuloTurmaCertificacao[]
  >([])
  const [disciplinasTurma, definirDisciplinasTurma] = useState<
    DisciplinaTurmaCertificacao[]
  >([])
  const [indexModulo, defineIndexModulo] = useState(null)

  const erroAoEnviarDocumentos = 'Erro ao enviar documentos.'
  const erroAoAtualizarDocumentos = 'Erro ao atualizar documentos.'
  const erroAoEnviarMotivoAlteracaoAprovado = 'Erro ao enviar motivo alteração'

  const toastOptions = { type: 'error' } as ToastOptions

  enum Navegacoes {
    DadosCurso = 'dados-curso',
    InformacoesFinanceiras = 'informacoes-financeiras',
    InformacoesIniciasCurso = 'informacoes-iniciais-curso',
    InformacoesCurso = 'informacoes-curso',
    Disciplinas = 'disciplinas',
    Avaliacoes = 'avaliacoes',
    GradeCurricular = 'grade-curricular',
    VersoCertificado = 'verso-certificado',
    PesquisaSatisfacao = 'pesquisa-satisfacao'
  }

  useEffect(() => {
    if (modo === ModoPaginaCadastro.Edicao) {
      setIdTurma(match.params.id)
    }
  }, [])

  const focarNoPrimeiroErro = (idContexto?: string): void => {
    setTimeout(() => {
      const selecaoDoEditor = '#informacoes-container > #erro-informacoes'
      return focarPrimeiroCampoOuEditorComErro(selecaoDoEditor)(idContexto)
    }, 0)
  }

  useEffect(() => {
    const carregarDados = async () => {
      try {
        const cursos = await Api.RequisitarTodosCursosCertificacao(
          usuarioId,
          visao
        )

        const listaProfessores = await RequisitarTodosProfessoresCertificacao(
          usuarioId,
          visao
        )

        const opcoesCurso = cursos.map((curso: any) => ({
          id: curso.id,
          texto: curso.nome
        }))

        const opcoesProfessor = listaProfessores.map((professor: any) => ({
          id: professor.id,
          texto: professor.nome
        }))

        definirOpcoesCurso(opcoesCurso)
        definirOpcoesProfessor(opcoesProfessor)
        definirProfessores(listaProfessores)

        if (modo === ModoPaginaCadastro.Edicao) {
          const turmaParaEdicao = await Api.RequisitarTurmaCertificacao(
            match.params.id
          )
          const cursoCertificacao = await Api.RequisitarCursoCertificacao(
            turmaParaEdicao.cursoCertificacaoId
          )

          definirModulosTurma(turmaParaEdicao?.modulosCertificacao)
          definirDisciplinasTurma(turmaParaEdicao?.disciplinasCertificacao)

          if (turmaParaEdicao?.documentoTurmaCertificacao?.length > 0) {
            definirPossuiDocumentosSalvos(true)
          }

          let professoresComDados = []
          if (cursoCertificacao.divisao === 'Modulo') {
            professoresComDados = cursoCertificacao?.modulosCertificacao?.flatMap(
              (modulo: any) =>
                modulo.disciplinasMCertificacao?.map((disciplina: any) => ({
                  nome:
                    disciplina.professorDisciplinasModuloCertificacao?.[0]
                      ?.nomeProfessor ?? '',
                  disciplinaId: disciplina.id,
                  disciplinaNome: disciplina.nome,
                  divisao: cursoCertificacao.divisao
                })) || []
            )
          } else {
            professoresComDados = cursoCertificacao.disciplinasCertificacao.map(
              disciplina => {
                return (
                  {
                    nome:
                      disciplina.professorDisciplinasCertificacao?.[0]
                        ?.nomeProfessor ?? '',
                    disciplinaId: disciplina.id,
                    disciplinaNome: disciplina.nome,
                    divisao: cursoCertificacao.divisao
                  } || []
                )
              }
            )
          }
          definirTurma({
            ...turmaParaEdicao,
            professores: professoresComDados
          })
        }
      } catch (e) {
        // eslint-disable-next-line
        console.error(e)
      }
    }

    carregarDados()
    definirPronto(true)
  }, [usuarioId])

  const uploadDeCriacao = async (
    turmaId: string,
    documentos: UploadDocumentos[]
  ): Promise<void> => {
    try {
      const formulario = ResumoDeDocumentosDeSaidaMapper(documentos)
      const resposta = await Api.EnviarDocumentosTurmaCertificacao(
        turmaId,
        formulario
      )

      if (!resposta) {
        toast(erroAoEnviarDocumentos, toastOptions)
      }
    } catch (erro) {
      toast(erroAoEnviarDocumentos, toastOptions)
    }
  }

  const uploadDeEdicao = async (
    turmaId: string,
    documentos: UploadDocumentos[]
  ): Promise<void> => {
    try {
      const formulario = ResumoDeDocumentosDeSaidaMapper(documentos)
      const resposta = await Api.EditarDocumentosTurmaCertificacao(
        turmaId,
        formulario
      )

      if (resposta) {
        const documentosAprovados = documentos.filter(
          x => x.motivoAlteracaoAprovado
        )

        if (documentosAprovados?.length > 0) {
          try {
            await Api.AlteracaoAprovado(turmaId, documentosAprovados)
          } catch {
            toast(erroAoEnviarMotivoAlteracaoAprovado, toastOptions)
          }
        }
      } else {
        toast(erroAoAtualizarDocumentos, toastOptions)
      }
    } catch (erro) {
      toast(erroAoAtualizarDocumentos, toastOptions)
    }
  }

  const adicionarModulo = (modulo: ModuloTurmaCertificacao) => {
    const novosModulos = [...modulosTurma, { ...modulo, disciplinas: [] }]
    definirModulosTurma(novosModulos)
  }

  const editarModulo = (moduloEditado: any) => {
    const novosModulos = modulosTurma.map((modulo, idx) => {
      if (idx === indexModulo) {
        return {
          ...modulo,
          nome: moduloEditado.nome
        }
      }
      return modulo
    })

    definirModulosTurma(novosModulos)
  }

  const adicionarDisciplina = (disciplina: any) => {
    const professorSelecionado = professores.find(
      p => p.id === disciplina.professor
    )

    const professorFormatado = {
      idProfessor: professorSelecionado.id,
      nomeProfessor: professorSelecionado.nome,
      disciplinaCertificacaoId: null,
      disciplinaModuloCertificacaoId: null,
      nomeDisciplina: disciplina.nome
    }

    const novaDisciplina: DisciplinaCertificacaoVinculada = {
      id: disciplina.id,
      nome: disciplina.nome,
      cargaHoraria: Number(disciplina.cargaHoraria),
      deletado: false,
      professorDisciplinasCertificacao: [professorFormatado]
    }

    const novasDisciplinas = [...disciplinasTurma]

    if (disciplina.modo === 'editar' && disciplina.indexDisciplina !== null) {
      // ✏️ atualiza disciplina existente
      novasDisciplinas[disciplina.indexDisciplina] = novaDisciplina
    } else {
      // ➕ adiciona nova
      novasDisciplinas.push(novaDisciplina)
    }

    definirDisciplinasTurma(novasDisciplinas)
  }

  const excluirDisciplina = (indexDisciplina: number) => {
    const disciplinasAtualizadas = disciplinasTurma.map(
      (p: DisciplinaTurmaCertificacao, idx: number) => {
        if (idx === indexDisciplina) {
          p.deletado = true
        }
        return p
      }
    )

    definirDisciplinasTurma(disciplinasAtualizadas)
  }

  const vinculaDisciplina = (disciplina: any) => {
    const moduloIdx = disciplina.indexModulo ?? indexModulo

    if (moduloIdx < 0 || moduloIdx >= modulosTurma.length) {
      return
    }

    const modulosAtualizados = [...modulosTurma]
    const moduloAtual = modulosAtualizados[moduloIdx]
    const disciplinasModulo = moduloAtual.disciplinasMCertificacao || []

    const professorSelecionado = professores.find(
      p => p.id === disciplina.professor
    )

    const professorFormatado = {
      idProfessor: professorSelecionado.id,
      nomeProfessor: professorSelecionado.nome,
      disciplinaCertificacaoId: null,
      disciplinaModuloCertificacaoId: null,
      nomeDisciplina: disciplina.nome
    }

    const novaDisciplina: DisciplinaCertificacaoVinculada = {
      id: disciplina.id,
      nome: disciplina.nome,
      cargaHoraria: Number(disciplina.cargaHoraria),
      deletado: false,
      professorDisciplinasModuloCertificacao: [professorFormatado]
    }

    const novasDisciplinas = [...disciplinasModulo]

    if (
      disciplina.modo === 'editar' &&
      disciplina.indexDisciplina !== null &&
      disciplina.indexDisciplina >= 0
    ) {
      // ✏️ editar disciplina existente
      novasDisciplinas[disciplina.indexDisciplina] = novaDisciplina
    } else {
      // ➕ adicionar nova disciplina
      novasDisciplinas.push(novaDisciplina)
    }

    modulosAtualizados[moduloIdx] = {
      ...moduloAtual,
      disciplinasMCertificacao: novasDisciplinas
    }

    definirModulosTurma(modulosAtualizados)
  }

  const desvincularDisciplina = (
    indexModulo: number,
    indexDisciplina: number
  ) => {
    const modulosAtualizados =
      modulosTurma.map((item, index) => {
        if (index === indexModulo) {
          item = {
            ...item,
            disciplinasMCertificacao: [
              ...item.disciplinasMCertificacao.map(
                (p: DisciplinaCertificacaoVinculada, idx: number) => {
                  if (idx === indexDisciplina) {
                    p.deletado = true
                  }
                  return p
                }
              )
            ]
          }
        }
        return item
      }) ?? []
    definirModulosTurma(modulosAtualizados)
  }

  const documentosSelecionados = useMemo(() => {
    if (!documentos) return 0

    const { contador } = selecaoDeDocumentosParaEnvio(documentos)
    return contador
  }, [documentos])

  const acaoSucesso = async (turma: TurmaCertificacaoPayload) => {
    try {
      definirCarregando(true)

      const { edicoes, criacoes, contador } = selecaoDeDocumentosParaEnvio(
        documentos
      )

      let modulosCertificacao: ModuloTurmaCertificacao[] = []
      let disciplinasCertificacao: DisciplinaTurmaCertificacao[] = []

      if (turma.divisao === DivisaoCursoCertificacao.Modulo) {
        modulosCertificacao = modulosTurma.map((modulo, indexModulo) => ({
          ...modulo,
          ordem: indexModulo + 1,
          disciplinasMCertificacao:
            modulo.disciplinasMCertificacao?.map(
              (disciplina, indexDisciplina) => ({
                ...disciplina,
                ordem: indexDisciplina + 1,
                deletado:
                  disciplina.deletado === undefined
                    ? false
                    : disciplina.deletado
              })
            ) ?? []
        }))
      } else {
        disciplinasCertificacao = disciplinasTurma.map((disciplina, index) => ({
          ...disciplina,
          ordem: index + 1,
          deletado:
            disciplina.deletado === undefined ? false : disciplina.deletado
        }))
      }

      const professoresArray = turma.professores?.map((professor: any) => ({
        nome: professor.nome,
        disciplinaId: professor.disciplinaId,
        disciplinaNome: professor.disciplinaNome,
        divisao: professor.divisao
      }))

      const dataFimNormalizada = turma.tipo === 'Aberta' ? null : turma.dataFim

      const payload: TurmaCertificacaoPayload = {
        ...turma,
        dataFim: dataFimNormalizada,
        modulosCertificacao,
        disciplinasCertificacao,
        ...(professoresArray?.length > 0 && { professores: professoresArray })
      }

      if (modo === ModoPaginaCadastro.Inclusao) {
        try {
          const response = await Api.InserirTurmaCertificacao(
            payload,
            usuarioId
          )
          setIdTurma(response.turmaId)
          if (contador !== 0) {
            uploadDeCriacao(response.turmaId, criacoes)
          }
        } catch (erro) {
          // eslint-disable-next-line
          console.error('Falha ao criar turma')
        }
      } else {
        await Api.EditarTurmaCertificacao(match.params.id, payload, usuarioId)

        if (contador !== 0) {
          if (criacoes.length > 0) {
            await uploadDeCriacao(match.params.id, criacoes)
          }

          if (edicoes.length > 0) {
            await uploadDeEdicao(match.params.id, edicoes)
          }
        }
        setIdTurma(match.params.id)
      }

      history.push(RotasTurmaCertificacao.Turmas)
    } finally {
      definirCarregando(false)
    }
  }

  const cursoAlterado = async (opcao: SelectOpcao) => {
    if (opcao?.id) {
      try {
        const cursoAtualizado = await Api.RequisitarCursoCertificacao(opcao.id)
        let professoresComDados = []
        if (cursoAtualizado.divisao === 'Modulo') {
          professoresComDados = cursoAtualizado?.modulosCertificacao?.flatMap(
            (modulo: any) =>
              modulo.disciplinasMCertificacao?.map((disciplina: any) => ({
                nome:
                  disciplina.professorDisciplinasModuloCertificacao?.[0]
                    ?.nomeProfessor ?? '',
                disciplinaId: disciplina.id,
                disciplinaNome: disciplina.nome,
                divisao: cursoAtualizado.divisao
              })) || []
          )
        } else {
          professoresComDados = cursoAtualizado.disciplinasCertificacao.map(
            disciplina => {
              return (
                {
                  nome:
                    disciplina.professorDisciplinasCertificacao?.[0]
                      ?.nomeProfessor ?? '',
                  disciplinaId: disciplina.id,
                  disciplinaNome: disciplina.nome,
                  divisao: cursoAtualizado.divisao
                } || []
              )
            }
          )
        }

        definirTurma(turmaAntiga => ({
          ...turmaAntiga,
          professores: professoresComDados
        }))
      } catch (erro) {
        // eslint-disable-next-line
        console.error('Erro ao buscar curso selecionado', erro)
      }
    }
  }

  const divisaoAlterada = (opcao: SelectOpcao) => {
    definirDivisao(opcao?.id)
  }

  const isParceiro = visao === Visao.ParceiroCertificacao

  return (
    <ContainerCertificacao>
      {pronto ? (
        <Container>
          <ContainerMain>
            <ContainerLink>
              <Link
                texto="Voltar"
                href={RotasTurmaCertificacao.Turmas}
                icone={IconeBack}
              />
            </ContainerLink>
            <Cabecalho>
              <Breadcrumb
                titulo={titulo}
                atalhos={[
                  {
                    texto: 'Acadêmico',
                    acao: () => history.goBack()
                  },
                  {
                    texto: 'Turmas',
                    acao: () => history.goBack()
                  },
                  {
                    texto: titulo
                  }
                ]}
              />
            </Cabecalho>
            <Conteudo>
              <FormContainer>
                <FormUnform
                  key={turma?.id ?? turma?.nome}
                  schema={createSchema}
                  dadosIniciais={turma}
                  acaoSucesso={dadosAtualizados => {
                    documentosRef.current?.enviarDocumentos()
                    acaoSucesso(dadosAtualizados)
                  }}
                  acaoFalha={focarNoPrimeiroErro}
                >
                  <SecaoPrimaria id={Navegacoes.DadosCurso}>
                    <SubTitulo texto="Dados da Turma" />
                    <ContainerDados>
                      <ContainerDadosMedio>
                        <InputUnform
                          name="nome"
                          label="Nome da Turma"
                          obrigatorio
                          maxLength={200}
                          disabled={!isParceiro}
                        />
                      </ContainerDadosMedio>
                      <ContainerDadosMedio>
                        <SelectUnform
                          id="slct_cursoTurma"
                          name="cursoCertificacaoId"
                          label="Curso"
                          obrigatorio
                          valorAlterado={cursoAlterado}
                          margemInferior={false}
                          opcoes={opcoesCurso}
                          disabled={!isParceiro}
                        />
                      </ContainerDadosMedio>
                      <ContainerDadosMedio>
                        <SelectUnform
                          id="slct_divisao"
                          name="divisao"
                          label="Divisão da turma"
                          disabled={
                            modo === ModoPaginaCadastro.Edicao || !isParceiro
                          }
                          obrigatorio
                          valorAlterado={divisaoAlterada}
                          margemInferior={false}
                          opcoes={[
                            {
                              id:
                                DivisaoCursoCertificacao[
                                  DivisaoCursoCertificacao.Modulo
                                ],
                              texto:
                                DivisaoCursoCertificacao[
                                  DivisaoCursoCertificacao.Modulo
                                ]
                            },
                            {
                              id:
                                DivisaoCursoCertificacao[
                                  DivisaoCursoCertificacao.Disciplina
                                ],
                              texto:
                                DivisaoCursoCertificacao[
                                  DivisaoCursoCertificacao.Disciplina
                                ]
                            }
                          ]}
                        />
                      </ContainerDadosMedio>
                    </ContainerDados>
                    <ContainerDados style={{ marginBottom: '20px' }}>
                      <ContainerDadosMedio>
                        <SelectUnform
                          id="slct_status"
                          name="status"
                          label="Situação da turma"
                          obrigatorio
                          margemInferior={false}
                          disabled={!isParceiro}
                          opcoes={[
                            {
                              id:
                                SituacaoTurmaCertificacao[
                                  SituacaoTurmaCertificacao.AguardandoInicio
                                ],
                              texto: 'Aguardando Início'
                            },
                            {
                              id:
                                SituacaoTurmaCertificacao[
                                  SituacaoTurmaCertificacao.Emandamento
                                ],
                              texto: 'Em Andamento'
                            },
                            {
                              id:
                                SituacaoTurmaCertificacao[
                                  SituacaoTurmaCertificacao.Finalizada
                                ],
                              texto:
                                SituacaoTurmaCertificacao[
                                  SituacaoTurmaCertificacao.Finalizada
                                ]
                            },
                            {
                              id:
                                SituacaoTurmaCertificacao[
                                  SituacaoTurmaCertificacao.Cancelada
                                ],
                              texto:
                                SituacaoTurmaCertificacao[
                                  SituacaoTurmaCertificacao.Cancelada
                                ]
                            }
                          ]}
                        />
                      </ContainerDadosMedio>
                      <ContainerDadosMedio>
                        <SelectUnform
                          id="slct_tipo"
                          name="tipo"
                          label="Tipo da turma"
                          obrigatorio
                          margemInferior={false}
                          disabled={!isParceiro}
                          valorAlterado={tipo => definirTipoTurma(tipo)}
                          opcoes={[
                            {
                              id:
                                TipoTurmaCertificacao[
                                  TipoTurmaCertificacao.Aberta
                                ],
                              texto: 'Entrada de alunos diária'
                            },
                            {
                              id:
                                TipoTurmaCertificacao[
                                  TipoTurmaCertificacao.Fechada
                                ],
                              texto: 'Entrada de alunos até data estipulada'
                            }
                          ]}
                        />
                      </ContainerDadosMedio>
                      <ContainerDadosMedio>
                        <NumeroInputUnform
                          name="cargaHoraria"
                          label="Carga Horária Obrigatória (em horas)"
                          maxLength={9}
                          obrigatorio
                          isDecimal={true}
                          disabled={!isParceiro}
                        />
                      </ContainerDadosMedio>
                    </ContainerDados>
                    <ContainerDados>
                      <ContainerDadosMedio>
                        <CalendarioUnform
                          className="sm"
                          id="ipt_data_inicio"
                          name="dataInicio"
                          label="Data de Início da Turma"
                          obrigatorio
                          disabled={!isParceiro}
                        />
                      </ContainerDadosMedio>
                      {tipoTurma?.id !== 'Aberta' && (
                        <ContainerDadosMedio>
                          <CalendarioUnform
                            className="sm"
                            id="ipt_data_fim"
                            name="dataFim"
                            label="Data de Fim da Turma"
                            obrigatorio
                            disabled={!isParceiro}
                          />
                        </ContainerDadosMedio>
                      )}
                    </ContainerDados>
                    <ContainerDados>
                      <ContainerDadosMedio>
                        <SelectUnform
                          id="slct_tipoCertificado"
                          name="tipoCertificado"
                          label="Tipo de certificado"
                          margemInferior={false}
                          disabled={isParceiro}
                          opcoes={[
                            {
                              id: TipoCertificado[TipoCertificado.Digital],
                              texto: TipoCertificado[TipoCertificado.Digital]
                            },
                            {
                              id: TipoCertificado[TipoCertificado.Fisico],
                              texto: 'Físico'
                            }
                          ]}
                        />
                      </ContainerDadosMedio>
                      <ContainerDadosMedio>
                        <NumeroInputUnform
                          name="valorCertificacao"
                          label="Valor do Certificado"
                          maxLength={9}
                          // obrigatorio
                          isDecimal={true}
                          disabled={isParceiro}
                        />
                      </ContainerDadosMedio>
                    </ContainerDados>
                    <ContainerDados>
                      <ContainerDadosGrande>
                        <ErroLayoutContainer.Provider>
                          <DocumentosTurmaCertificacao
                            ref={documentosRef}
                            turmaCertificacaoId={idTurma}
                            documentos={documentos}
                            atualizar={atualizar}
                            reiniciar={reiniciar}
                          />
                        </ErroLayoutContainer.Provider>
                      </ContainerDadosGrande>
                    </ContainerDados>
                  </SecaoPrimaria>
                  <Spacer padding="10px 0px" />
                  <ListaModuloDisciplina
                    modulos={modulosTurma}
                    disciplinas={disciplinasTurma}
                    usuarioId={usuarioId}
                    divisao={divisaoTurma}
                    modalIncluirModuloRef={modalIncluirModuloRef}
                    modalIncluirDisciplinaRef={modalIncluirDisciplinaRef}
                    modalExcluirDisciplinaRef={modalExcluirDisciplinaref}
                    modalEditarModuloRef={modalEditarModuloRef}
                    modalDisciplinaModuloRef={modalDisciplinaModuloRef}
                    modalDesvincularDisciplinaref={
                      modalDesvincularDisciplinaref
                    }
                    defineIndexModulo={defineIndexModulo}
                  />
                  <ContainerAcoes>
                    <Botao
                      texto={'Cancelar'}
                      tema="Secundario"
                      type="button"
                      disabled={carregando}
                      onClick={() =>
                        isParceiro
                          ? modalRef.current?.abrir()
                          : history.push(RotasTurmaCertificacao.Turmas)
                      }
                    />
                    <Botao
                      type="submit"
                      texto="Salvar"
                      carregando={carregando}
                      disabled={
                        carregando ||
                        (documentosSelecionados === 0 &&
                          !possuiDocumentosSalvos)
                      }
                    />
                  </ContainerAcoes>
                </FormUnform>
              </FormContainer>
            </Conteudo>
          </ContainerMain>
          <Modal
            ref={modalRef}
            backdrop
            id="modal-confirmacao-cancelamento"
            icone={<></>}
            titulo={'Deseja cancelar?'}
            acaoPrimaria={{
              titulo: 'Sim',
              tipo: 'button',
              acao: () => history.goBack()
            }}
            acaoSecundario={{
              titulo: 'Não',
              tipo: 'button',
              acao: () => modalRef.current?.fechar()
            }}
          >
            <p>Selecione uma opção</p>
          </Modal>
          <ModalIncluirModulo
            id="modal-incluir-modulo"
            backdrop
            ref={modalIncluirModuloRef}
            acaoPrimaria={adicionarModulo}
          />
          <ModalIncluirDisciplina
            id="modal-incluir-modulo"
            backdrop
            ref={modalIncluirDisciplinaRef}
            acaoPrimaria={adicionarDisciplina}
            opcoesProfessor={opcoesProfessor}
          />
          <ModalExcluirDisciplina
            ref={modalExcluirDisciplinaref}
            backdrop={true}
            acaoPrimaria={({ indexDisciplina }) =>
              excluirDisciplina(indexDisciplina)
            }
          />
          <ModalEditarModulo
            id="modal-editar-modulo"
            backdrop
            ref={modalEditarModuloRef}
            acaoPrimaria={editarModulo}
          />
          <ModalVincularDisciplinaModulo
            id="modal-vincular-curso"
            ref={modalDisciplinaModuloRef}
            acaoPrimaria={dados => {
              vinculaDisciplina(dados)
              modalDisciplinaModuloRef?.current?.fechar()
            }}
            opcoesProfessor={opcoesProfessor}
            backdrop
            titulo="Vincular Disciplina"
          />
          <DesvincularDisciplinaModulo
            ref={modalDesvincularDisciplinaref}
            backdrop={true}
            acaoPrimaria={({ indexModulo, indexDisciplina }) =>
              desvincularDisciplina(indexModulo, indexDisciplina)
            }
          />
        </Container>
      ) : (
        <></>
      )}
    </ContainerCertificacao>
  )
}

export default withRouter(PaginaTurmas)
